import { graphql } from '@teachino/shared-infrastructure';
import type { ResultOf } from 'gql.tada';

export const materialListItemFragment = graphql(`
  fragment MaterialListItem on Material {
    __typename
    id
    name
    icon
    duration
    contentStatistics {
      __typename
      fileCount
      imageCount
      linkCount
      noteCount
      interactiveAssignmentCount
    }
    topic {
      __typename
      id
      name
      usage
    }
  }
`);

export type MaterialListItem = ResultOf<typeof materialListItemFragment>;
